<section class="date-picker-section">
	<label *ngIf="label"
	       class="label"
	       (click)="dateInput.focus()">
		<span>{{label}}</span>
		<span *ngIf="isRequired" class="required-star"> *</span>
	</label>
	<input #dateInput
	       type="date"
	       class="date-value date-input"
	       max="9999-12-31"
	       [ngModel]="date | date: dateFormat"
	       (focusin)="isFocused = true"
	       (focusout)="isFocused = false; onTouch(date)"
	       (ngModelChange)="setDateFromDateString($event)">
	<img #datePicker=bsDatepicker
	     src="assets/icons/svg/ic_Date-Picker_Dark_40x40.svg"
	     alt="calendar image"
	     bsDatepicker
	     [id]="id+'-date-picker'"
	     [placement]="placement"
			 [datesDisabled]="disabledDates"
	     [container]="'#date-picker'"
	     [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false, selectFromOtherMonth: true}"
	     [ngClass]="{'disabled': isDisabled}"
	     [isDisabled]="isDisabled"
	     [minDate]="minDate"
	     [maxDate]="maxDate"
	     [bsValue]="date"
	     (bsValueChange)="updateValue($event, datePicker.isOpen)">
</section>

